import { getWithAuth, putWithAuth } from '../InitializeService';
import { AxiosInstance } from 'axios';
import { buildODataQuery, ODataParams } from '@/utils/odataUtil';

export const getByLoginName = (loginName: string, instance: AxiosInstance, params?: ODataParams) => {
  // buildODataQuery returns "?k=v&..." — drop the "?" and join onto the existing query string with "&"
  const odataQuery = params ? '&' + buildODataQuery(params).slice(1) : '';
  return getWithAuth(`mysite/suggestions?loginname=${loginName}${odataQuery}`, instance);
}
export const dismissById = (instance: AxiosInstance, suggestionId: number, reason: string, login: string) => {
  return putWithAuth(
    `mysite/suggestions/${suggestionId}/dismiss`,
    {
      'dismissedNotes': reason,
      'userAccount': 'positive\\' + login
    },
    instance
  );
}